import { useLayoutEffect } from 'react';

/**
 * Updates Table of Contents page numbers based on actual DOM layout after pagination.
 * Runs after useReportPagination (which uses 1000ms) to account for sections that
 * span multiple pages when split by the pagination hook.
 */
export const useTocPageNumbers = (containerId: string, delayMs: number = 1200) => {
  useLayoutEffect(() => {
    const timer = setTimeout(() => {
      const container = document.getElementById(containerId);
      if (!container) return;

      const inner = container.querySelector('.report-content-inner');
      if (!inner) return;

      // All pages in DOM order: cover first, then all .report-page (including generated splits)
      const cover = inner.querySelector('.report-cover');
      const reportPages = Array.from(inner.querySelectorAll(':scope > .report-page'));
      const allPages: Element[] = cover
        ? [cover, ...reportPages]
        : reportPages;

      const tocSpans = container.querySelectorAll<HTMLElement>('[data-toc-page-for]');
      tocSpans.forEach((span) => {
        const sectionId = span.getAttribute('data-toc-page-for');
        if (!sectionId) return;

        const target = document.getElementById(sectionId);
        if (!target) return;

        const pageEl = target.closest('.report-page') ?? target.closest('.report-cover');
        if (!pageEl) return;

        const pageIndex = allPages.indexOf(pageEl);
        if (pageIndex >= 0) {
          span.textContent = String(pageIndex + 1);
        }
      });
    }, delayMs);

    return () => clearTimeout(timer);
  }, [containerId, delayMs]);
};
